import { render, staticRenderFns } from "./IconRating.vue?vue&type=template&id=59a820f8"
import script from "./IconRating.vue?vue&type=script&lang=js"
export * from "./IconRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports